import {
    AuthenticateGuard,
    ButtonModule,
    HandlerErrorService,
    ModalsModule,
    SosAuthorizationStoreModule,
    SosCoreConfig,
    SystemIconModule,
} from '@serviceos-ng/core';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { Route, RouterModule } from '@angular/router';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    SosCoreModule
} from '@serviceos-ng/core';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsModule } from '@ngxs/store';
import { AccountsHandlerErrorService } from './accounts-handler-error.service';

interface AppWindow extends Window {
  config?: SosCoreConfig;
}

const config: SosCoreConfig = {
  api_url: (window as AppWindow).config?.api_url || '',
  profile_id: (window as AppWindow).config?.profile_id || '',
  key: (window as AppWindow).config?.key || '',
};

const appRoutes: Route[] = [
    {
        path: 'auth',
        loadChildren: () =>
            import(
                '@serviceos-ng/screens/authentication-screens/authentication-screens.module'
            ).then((m) => m.AuthenticationScreensModule)
    },
    {
        path: 'create-account',
        redirectTo: 'auth/create-account'
    },
    {
        path: 'referral',
        loadComponent: () =>
            import(
                '@serviceos-ng/screens/authentication-screens/referral-redirect/referral-redirect.component'
            ).then((m) => m.ReferralRedirectComponent),
        },
    {
        path: 'recover-password/:id',
        redirectTo: 'auth/recover-password/:id',
        pathMatch: 'full'
    },
    {
        path: 'recover-password',
        redirectTo: 'auth/recover-password',
        pathMatch: 'full'
    },
    {
        path: 'recover-password/',
        redirectTo: 'auth/recover-password',
        pathMatch: 'full'
    },
    {
        path: '',
       loadChildren: () =>
        import('@serviceos-web/domains/accounts').then(
            (m) => m.DomainAccountsRootModule
        ),
        canLoad: [AuthenticateGuard],
        // resolve: [LocalizationResolver],
        // canActivate: [AuthenticateGuard],
        runGuardsAndResolvers: 'always',
        data: {
            themeSwitchCases: {},
            // routeLocalizationConfig: new RouteLocalizationConfig({
            //     key: 'app',
            //     path: 'lib/domain-accounts-root',
            //     modules: ['application', 'customer', 'chat'],
            // }),
        },
    }
    
];

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, {
            initialNavigation: 'enabledNonBlocking',
            onSameUrlNavigation: 'reload',
            scrollPositionRestoration: 'enabled',
            // enableTracing: !environment.production,
        }),
        NgxsModule.forRoot([], {
            developmentMode: !environment.production,
            selectorOptions: {
                suppressErrors: false,
                injectContainerState: false,
            },
        }),
        NgxsReduxDevtoolsPluginModule.forRoot({
            disabled: environment.production,
        }),
        NgxsLoggerPluginModule.forRoot({ disabled: environment.production }),
        SosCoreModule.forRoot(config, environment),
        ButtonModule,
        SystemIconModule,
        ModalsModule,
        SosAuthorizationStoreModule
    ],
    providers: [
        {
            provide: HandlerErrorService,
            useClass: AccountsHandlerErrorService,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {

    constructor(
        // private segmentService: SegmentService,
    
    ) {
        // Check client name for condition for now
        // if (
        //     config?.api_url?.includes('urban') &&
        //     !config?.api_url?.includes('customer') &&
        //     !window.location.hostname.includes('local')
        // ) {
        //     this.segmentService.load('ogkc3vfBgHVBpOarhsulBnfLEX1toFIu');
        // }
    }

}
